let app = null;
let sidebarChildren = {};
function setApp(template) {
  app = template;
}
function closeSidebar(sidebarName = "left") {
  //get sidebar div
  let sidebarSelector = ".column.side." + sidebarName;
  let sidebarDiv = app?.template.querySelector(sidebarSelector);

  //make sidebar div visible
  if (sidebarDiv) {
    sidebarDiv.style.display = "none";
  }
}
function openSidebar(sidebarChildElementId, sidebarName = "left") {
  //get sidebar div
  let sidebarSelector = ".column.side." + sidebarName;
  let $sidebarDiv = $(app?.template.querySelector(sidebarSelector));
  console.log("sidebarDiv", $sidebarDiv);
  //make sidebar div visible
  if ($sidebarDiv.length > 0) {
    $sidebarDiv.css("display", "block");
  }
  // Now that the parent div is open, move down into the child div where we will be placing the content. This avoids any LWC errors.
  const contentDivClass = `.${sidebarName}ColumnBody`;
  $sidebarDiv = $sidebarDiv.find(contentDivClass);
  if (sidebarChildElementId) {
    //loop over all sidebar child elements, hide all children except the id that is passed
    $sidebarDiv.children(".sidebar-child").each(function () {
      let childElement = this;
      if ($(childElement).data("id") === sidebarChildElementId) {
        $(childElement).css("display", "block");
      } else {
        $(childElement).css("display", "none");
      }
    });
  }
}
function clearSidebar() {
  let sidebarSelectorLeft = ".column.side.left";
  let sidebarSelectorRight = ".column.side.right";
  let sidebarDivLeft = app?.template.querySelector(sidebarSelectorLeft);
  let sidebarDivRight = app?.template.querySelector(sidebarSelectorRight);
  $(sidebarDivLeft).find(".sidebar-child").each(function () {
    console.log("child to be removed ", this);
    let childElement = this;
    $(childElement).remove();
  });
  $(sidebarDivRight).find(".sidebar-child").each(function () {
    console.log("child to be removed ", this);
    let childElement = this;
    $(childElement).remove();
  });
  console.log("after clearing out sidebars");
  console.log("sidebarDivLeft ", sidebarDivLeft);
  console.log("sidebarDivRight ", sidebarDivRight);
}
function addChildToSidebar(sidebarChildId, sidebarChildBody, sidebarName = "left") {
  //get sidebar div
  let sidebarSelector = ".column.side." + sidebarName;
  let $sidebarDiv = $(app?.template.querySelector(sidebarSelector));
  // Move down into the child div where we will be placing the content. This avoids any LWC errors.
  const contentDivClass = `.${sidebarName}ColumnBody`;
  $sidebarDiv = $($sidebarDiv).find(contentDivClass);
  const $sidebarChildBody = $(sidebarChildBody);

  //append the child element body to sidebar
  $sidebarChildBody.data("id", sidebarChildId);
  $sidebarChildBody.addClass("sidebar-child");
  $sidebarChildBody.addClass(sidebarChildId);
  $sidebarChildBody.css("display", "block");
  $sidebarDiv.append(sidebarChildBody);
  //this is not in use, thinking if we need to keep a reference
  sidebarChildren[sidebarChildId] = sidebarChildren[sidebarChildId] || {};
  sidebarChildren[sidebarChildId].sidebarName = sidebarChildId;
  sidebarChildren[sidebarChildId].sidebarBody = sidebarChildBody;
}
function getSidebarDom(sidebarChildId, sidebarName = "left") {
  let sidebarSelector = ".column.side." + sidebarName;
  let sidebarDiv = app?.template.querySelector(sidebarSelector);
  return $(sidebarDiv).find("." + sidebarChildId);
}
export { setApp, openSidebar, closeSidebar, addChildToSidebar, clearSidebar, getSidebarDom };